/**
 * Main JavaScript Entry Point
 *
 * This file imports and initializes all JavaScript modules for the blog.
 * Add new feature modules here as your blog grows.
 */

// Import modules
import { initCopyCode } from './modules/copy-code.js';
import { initMobileMenu } from './modules/mobile-menu.js';
import { initTableOfContents } from './modules/table-of-contents.js';
import { initTagFilter } from './modules/tag-filter.js';

// Initialize all modules when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize code copy functionality
  initCopyCode();

  // Initialize mobile menu toggle
  initMobileMenu();

  // Initialize table of contents for blog posts
  initTableOfContents();

  // Initialize tag filtering on blog index
  initTagFilter();

  // Add more module initializations here as needed
  // Example:
  // initSearch();
  // initThemeToggle();
  // initComments();
});
